import React, {useState, useContext, useEffect} from 'react'
import {Typography, Grid} from '@material-ui/core'
import moment from 'moment'
import './StepSelectDate.scss'
import SelectedItems from '../SelectedItems'
import MonthView from '../Calendar/MonthView'
import CreateIcon from '@material-ui/icons/Create'
import EditableDateText from '../EditableDateText'
import {ReservationContext} from '../../../context/Reservation/Reservation'

const StepSelectDate = ({date_format, time_format}) => {
  const [dateSelection, setDateSelection] = useState('from')
  const [calendarView, setCalendarView] = useState('month') // month || week || day

  const ctxReservation = useContext(ReservationContext)

  const handleClickView = (e, view) => {
    setCalendarView(view)
  }

  const handleClickDay = (e, momentDate) => {
    if (dateSelection === null) {
      setDateSelection('from')
    }
    if (dateSelection === 'to') {
      ctxReservation.update('date_to', momentDate)
    }
  }
  const handleClickTime = (e, momentDate) => {
    if (dateSelection === 'from' || dateSelection === null) {
      ctxReservation.update('date_from', momentDate)
      setDateSelection('to')
      return
    }
    if (dateSelection === 'to') {
      ctxReservation.update('date_to', momentDate)
      setDateSelection(null)
    }
  }

  const handleClickSelectDate = (e, selection) => {
    if (dateSelection === selection) {
      setDateSelection(null)
    } else {
      setDateSelection(selection)
    }
  }

  useEffect(() => {
    if (ctxReservation.reservation.date_from) {
      setDateSelection(null)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <section>
        <Typography className="ap-typography ap-typography--lg">Select date/time</Typography>
        <div className="c-step-select-date" style={{marginTop: 16}}>
          <div
            className={`c-step-select-date__wrapper ${
              dateSelection === 'from' ? ' c-step-select-date__wrapper--selected' : null
            }`}
            onClick={e => handleClickSelectDate(e, 'from')}
          >
            <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
              From
            </Typography>
            <div
              className="c-step-select-date__control"
              onClick={e => (dateSelection === 'from' ? e.stopPropagation() : null)}
            >
              <EditableDateText
                onChange={(e, v) => ctxReservation.update('date_from', v)}
                value={ctxReservation.reservation.date_from}
                format={`${date_format} ${time_format}`}
              />
            </div>
          </div>
          <div
            className={`c-step-select-date__wrapper ${
              dateSelection === 'to' ? ' c-step-select-date__wrapper--selected' : null
            }`}
            onClick={e => handleClickSelectDate(e, 'to')}
          >
            <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
              To
            </Typography>
            <div
              className="c-step-select-date__control"
              onClick={e => (dateSelection === 'to' ? e.stopPropagation() : null)}
            >
              <EditableDateText
                onChange={(e, v) => ctxReservation.update('date_to', v)}
                value={ctxReservation.reservation.date_to}
                format={`${date_format} ${time_format}`}
              />
            </div>
          </div>
        </div>
      </section>
      <section style={{marginTop: 22}}>
        <Grid container style={{marginTop: 0}} spacing={2}>
          <Grid item xs={10} style={{flex: 1}}>
            {calendarView === 'month' && (
              <MonthView
                selectedFromMomentDate={ctxReservation.reservation.date_from}
                selectedToMomentDate={ctxReservation.reservation.date_to}
                onClickDay={handleClickDay}
                onClickTime={handleClickTime}
                dateSelection={dateSelection}
                disableDatesBefore={
                  dateSelection === 'to'
                    ? ctxReservation.reservation.date_from || moment()
                    : moment()
                }
                disableDatesAfter={
                  dateSelection === 'from' ? ctxReservation.reservation.date_to : null
                }
              />
            )}
          </Grid>
          <Grid item style={{width: 192}}></Grid>
        </Grid>
      </section>
    </>
  )
}

export default StepSelectDate
